import {ErrorBox} from './components/commons/error-box/ErrorBox'
import {Button} from './components/ui/button/Button'
import {AlertCircleIcon, ArrowRightIcon} from './assets/icons/icons'
import {Flexbox} from './components/ui/flexbox/FlexBox'
import {useNavigate} from 'react-router-dom'
import {ROUTE_HOME} from './utilities/constants/routeNames'
import {useTheme} from 'styled-components'
import {useTranslation} from 'react-i18next'
import {ContactUsModal} from './features/contact-us/components/contact-us-modal/ContactUsModal'
import {useState} from 'react'

export const ErrorBoundary = () => {
    const navigate = useNavigate()
    const theme = useTheme()
    const {t} = useTranslation()
    const [isContactUsModalOpen, setIsContactUsModalOpen] = useState(false)

    return (
        <>
            <ErrorBox
                cta={
                    <Flexbox fullWidth gap={4} align="center" justify="center">
                        <Button variant="primary" onClick={() => setIsContactUsModalOpen(true)}>
                            {t('commons:contact_us')}
                        </Button>
                        <Button onClick={() => navigate(ROUTE_HOME)}>
                            {t('not_found:cta')} <ArrowRightIcon height={16} />
                        </Button>
                    </Flexbox>
                }
                icon={<AlertCircleIcon style={{transform: 'scale(3)'}} fill={theme.palette.danger[400]} />}
                title={t('errors:default')}
            />
            {isContactUsModalOpen && <ContactUsModal onClose={() => setIsContactUsModalOpen(false)} />}
        </>
    )
}
